import { useEffect, useState } from "react";

export type ActivePage = "login" | "library" | "viewport" | "accountSettings";

const PAGE_STORAGE_KEY = "poseref_active_page";

function readPersistedPage(): ActivePage {
  try {
    const v = sessionStorage.getItem(PAGE_STORAGE_KEY);
    if (
      v === "login" ||
      v === "library" ||
      v === "viewport" ||
      v === "accountSettings"
    )
      return v;
  } catch {}
  return "login";
}

let activePage: ActivePage = readPersistedPage();
const listeners = new Set<() => void>();

export function setActivePage(page: ActivePage) {
  if (page === activePage) return;
  activePage = page;
  try {
    sessionStorage.setItem(PAGE_STORAGE_KEY, page);
  } catch {}
  for (const fn of listeners) fn();
}

export function getActivePage(): ActivePage {
  return activePage;
}

export function useActivePage(): ActivePage {
  const [, rerender] = useState(0);

  useEffect(() => {
    const listener = () => rerender((n) => n + 1);
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  return activePage;
}
